import { Component, OnInit, Input, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { TabsService, TabInfo } from '../services/tabs.service';
import { Router, NavigationEnd } from '@angular/router';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss']
})
export class TabsComponent {

    @Input() group: string;
    @Input() defaults: TabInfo[];

    constructor(public tabsService: TabsService) {

    }

}



// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/shared/tabs/tabs.component.ts